import React from 'react';
import './Services.css';

const Services = () => {
  return (
    <div className="services-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="hero-background">
          <img src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="Services Hero Background" />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <h1>Our Services</h1>
          <p>Comprehensive IT solutions designed to accelerate your digital transformation journey</p>
        </div>
      </section>

      {/* Services Overview */}
      <section className="services-overview">
        <div className="container">
          <h2 className="section-title">Comprehensive IT Solutions</h2>
          <p className="section-subtitle">From infrastructure to cloud, we provide end-to-end technology solutions under one roof</p>
          
          <div className="services-intro">
            <p>TecMates Infocom Private Limited specializes in helping organizations streamline their business processes through tailored technology solutions. Our mission is to be one of the most sought-after IT solution providers, recognized for our reliability, agility, and commitment to excellence.</p>
          </div>
        </div>
      </section>

      {/* IT Infrastructure Solutions */}
      <div id="infrastructure" className="service-section">
        <div className="container">
          <div className="service-header">
            <div className="service-icon-large">
              <i className="fas fa-server"></i>
            </div>
            <div className="service-content">
              <h2>IT Infrastructure Solutions</h2>
              <p>Comprehensive hardware and infrastructure solutions for reliable, high-performance computing environments</p>
            </div>
          </div>
          <div className="service-image">
            <img src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="IT Infrastructure" />
          </div>
          <div className="service-details">
            <div className="service-items">
              <div className="service-item">
                <i className="fas fa-desktop"></i>
                <div>
                  <h3>Desktops, Laptops & Peripherals</h3>
                  <p>Business-class computing solutions designed for reliability and performance. We provide enterprise-grade desktops, laptops, and peripherals from leading manufacturers.</p>
                  <ul>
                    <li>High-performance workstations</li>
                    <li>Business laptops and notebooks</li>
                    <li>Monitors, keyboards, and accessories</li>
                    <li>Custom configurations</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-server"></i>
                <div>
                  <h3>Servers, Workstations & Storage</h3>
                  <p>Scalable infrastructure solutions to support mission-critical workloads and data management requirements.</p>
                  <ul>
                    <li>Enterprise servers and workstations</li>
                    <li>Network attached storage (NAS)</li>
                    <li>Storage area networks (SAN)</li>
                    <li>Backup and disaster recovery</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-network-wired"></i>
                <div>
                  <h3>Structured Cabling & Data Center Setup</h3>
                  <p>Professional cabling solutions and data center infrastructure design and implementation.</p>
                  <ul>
                    <li>Structured cabling systems</li>
                    <li>Data center design and setup</li>
                    <li>Network infrastructure</li>
                    <li>Cable management solutions</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Networking & Connectivity */}
      <div id="networking" className="service-section">
        <div className="container">
          <div className="service-header">
            <div className="service-icon-large">
              <i className="fas fa-network-wired"></i>
            </div>
            <div className="service-content">
              <h2>Networking & Connectivity</h2>
              <p>Intelligent, secure, and high-performance networking solutions for modern enterprises</p>
            </div>
          </div>
          <div className="service-image">
            <img src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Networking" />
          </div>
          <div className="service-details">
            <div className="service-items">
              <div className="service-item">
                <i className="fas fa-globe"></i>
                <div>
                  <h3>SD-WAN Solutions</h3>
                  <p>Software-defined wide area network solutions for optimized connectivity and network management.</p>
                  <ul>
                    <li>Centralized network management</li>
                    <li>Dynamic path selection</li>
                    <li>Application-aware routing</li>
                    <li>Cost-effective connectivity</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-sitemap"></i>
                <div>
                  <h3>Enterprise LAN/WAN Design & Implementation</h3>
                  <p>Comprehensive network architecture design and deployment for enterprise environments.</p>
                  <ul>
                    <li>Network architecture design</li>
                    <li>Scalable network solutions</li>
                    <li>Performance optimization</li>
                    <li>Network security integration</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-wifi"></i>
                <div>
                  <h3>Wireless Network Solutions</h3>
                  <p>Advanced wireless networking for seamless connectivity and mobility.</p>
                  <ul>
                    <li>Enterprise wireless networks</li>
                    <li>Wi-Fi 6 implementation</li>
                    <li>Guest network solutions</li>
                    <li>Wireless security</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Cybersecurity Solutions */}
      <div id="security" className="service-section">
        <div className="container">
          <div className="service-header">
            <div className="service-icon-large">
              <i className="fas fa-shield-alt"></i>
            </div>
            <div className="service-content">
              <h2>Cybersecurity Solutions</h2>
              <p>Comprehensive protection against evolving cyber threats with next-generation security solutions</p>
            </div>
          </div>
          <div className="service-image">
            <img src="https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Cybersecurity" />
          </div>
          <div className="service-details">
            <div className="service-items">
              <div className="service-item">
                <i className="fas fa-fire"></i>
                <div>
                  <h3>Next-Gen Firewall & UTM</h3>
                  <p>Advanced firewall and unified threat management solutions for comprehensive network protection.</p>
                  <ul>
                    <li>Deep packet inspection</li>
                    <li>Intrusion prevention systems</li>
                    <li>Application control</li>
                    <li>Threat intelligence integration</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-laptop-shield"></i>
                <div>
                  <h3>Endpoint Security & Antivirus Solutions</h3>
                  <p>Comprehensive endpoint protection for all devices across your network.</p>
                  <ul>
                    <li>Real-time threat detection</li>
                    <li>Behavioral analysis</li>
                    <li>Ransomware protection</li>
                    <li>Centralized management</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-user-shield"></i>
                <div>
                  <h3>Identity & Access Management (IAM)</h3>
                  <p>Secure identity management and access control systems for enterprise environments.</p>
                  <ul>
                    <li>Multi-factor authentication</li>
                    <li>Single sign-on (SSO)</li>
                    <li>Privileged access management</li>
                    <li>Identity governance</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-search"></i>
                <div>
                  <h3>Network Security Audits & Compliance</h3>
                  <p>Security assessments and compliance management for regulatory requirements.</p>
                  <ul>
                    <li>Vulnerability assessments</li>
                    <li>Penetration testing</li>
                    <li>Compliance reporting</li>
                    <li>Security policy development</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Cloud & Virtualization */}
      <div id="cloud" className="service-section">
        <div className="container">
          <div className="service-header">
            <div className="service-icon-large">
              <i className="fas fa-cloud"></i>
            </div>
            <div className="service-content">
              <h2>Cloud & Virtualization</h2>
              <p>Scalable cloud solutions and virtualization technologies for modern IT infrastructure</p>
            </div>
          </div>
          <div className="service-image">
            <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Cloud Computing" />
          </div>
          <div className="service-details">
            <div className="service-items">
              <div className="service-item">
                <i className="fas fa-cloud-upload-alt"></i>
                <div>
                  <h3>Cloud Migration & Deployment</h3>
                  <p>Seamless cloud migration services for public, private, and hybrid cloud environments.</p>
                  <ul>
                    <li>Cloud strategy planning</li>
                    <li>Application migration</li>
                    <li>Data migration services</li>
                    <li>Cloud optimization</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-cube"></i>
                <div>
                  <h3>Virtualization (VMware, Hyper-V, etc.)</h3>
                  <p>Server and desktop virtualization solutions for improved resource utilization.</p>
                  <ul>
                    <li>Server virtualization</li>
                    <li>Desktop virtualization (VDI)</li>
                    <li>Application virtualization</li>
                    <li>Virtual machine management</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-sync-alt"></i>
                <div>
                  <h3>Backup & Disaster Recovery Solutions</h3>
                  <p>Comprehensive data protection and business continuity solutions.</p>
                  <ul>
                    <li>Automated backup systems</li>
                    <li>Disaster recovery planning</li>
                    <li>Business continuity testing</li>
                    <li>Data replication</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Collaboration & Communication */}
      <div id="collaboration" className="service-section">
        <div className="container">
          <div className="service-header">
            <div className="service-icon-large">
              <i className="fas fa-video"></i>
            </div>
            <div className="service-content">
              <h2>Collaboration & Communication</h2>
              <p>Seamless communication and collaboration tools for remote and hybrid teams</p>
            </div>
          </div>
          <div className="service-image">
            <img src="https://images.unsplash.com/photo-1518186285589-2f7649de83e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Collaboration" />
          </div>
          <div className="service-details">
            <div className="service-items">
              <div className="service-item">
                <i className="fas fa-video-camera"></i>
                <div>
                  <h3>Video & Audio Conferencing Solutions</h3>
                  <p>Enterprise-grade communication platforms for seamless remote collaboration.</p>
                  <ul>
                    <li>HD video conferencing</li>
                    <li>Audio conferencing systems</li>
                    <li>Meeting room solutions</li>
                    <li>Mobile collaboration</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-comments"></i>
                <div>
                  <h3>Unified Communication Platforms</h3>
                  <p>Integrated communication and collaboration tools for modern workplaces.</p>
                  <ul>
                    <li>Instant messaging</li>
                    <li>Voice over IP (VoIP)</li>
                    <li>Presence management</li>
                    <li>Team collaboration tools</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-tv"></i>
                <div>
                  <h3>Digital Signage & AV Solutions</h3>
                  <p>Digital display and audiovisual systems for effective communication.</p>
                  <ul>
                    <li>Digital signage displays</li>
                    <li>Content management systems</li>
                    <li>Audio-visual integration</li>
                    <li>Interactive displays</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Managed & AMC Services */}
      <div id="managed" className="service-section">
        <div className="container">
          <div className="service-header">
            <div className="service-icon-large">
              <i className="fas fa-tools"></i>
            </div>
            <div className="service-content">
              <h2>Managed & AMC Services</h2>
              <p>Comprehensive maintenance and support services to ensure operational continuity</p>
            </div>
          </div>
          <div className="service-image">
            <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Managed Services" />
          </div>
          <div className="service-details">
            <div className="service-items">
              <div className="service-item">
                <i className="fas fa-calendar-check"></i>
                <div>
                  <h3>Annual Maintenance Contracts (AMC)</h3>
                  <p>Comprehensive maintenance agreements for IT infrastructure and equipment.</p>
                  <ul>
                    <li>Preventive maintenance</li>
                    <li>Hardware support</li>
                    <li>Software updates</li>
                    <li>Performance monitoring</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-desktop"></i>
                <div>
                  <h3>Remote IT Support & Monitoring</h3>
                  <p>24/7 remote monitoring and support services for proactive issue resolution.</p>
                  <ul>
                    <li>24/7 system monitoring</li>
                    <li>Remote troubleshooting</li>
                    <li>Performance optimization</li>
                    <li>Alert management</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-headset"></i>
                <div>
                  <h3>IT Helpdesk Services</h3>
                  <p>Dedicated support desk for technical assistance and issue resolution.</p>
                  <ul>
                    <li>Multi-channel support</li>
                    <li>Ticket management</li>
                    <li>Knowledge base</li>
                    <li>Escalation procedures</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Consulting & Integration Services */}
      <div id="consulting" className="service-section">
        <div className="container">
          <div className="service-header">
            <div className="service-icon-large">
              <i className="fas fa-lightbulb"></i>
            </div>
            <div className="service-content">
              <h2>Consulting & Integration Services</h2>
              <p>Strategic IT consulting and seamless system integration for optimal performance</p>
            </div>
          </div>
          <div className="service-image">
            <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Consulting" />
          </div>
          <div className="service-details">
            <div className="service-items">
              <div className="service-item">
                <i className="fas fa-chart-line"></i>
                <div>
                  <h3>IT Strategy & Infrastructure Planning</h3>
                  <p>Strategic planning and roadmap development for technology transformation.</p>
                  <ul>
                    <li>Technology assessment</li>
                    <li>Roadmap development</li>
                    <li>Capacity planning</li>
                    <li>Budget optimization</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-puzzle-piece"></i>
                <div>
                  <h3>System Integration Services</h3>
                  <p>Seamless integration of diverse IT systems and applications.</p>
                  <ul>
                    <li>API integration</li>
                    <li>Data migration</li>
                    <li>System interoperability</li>
                    <li>Custom development</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-tasks"></i>
                <div>
                  <h3>Project Management & Implementation</h3>
                  <p>Professional project management and implementation services.</p>
                  <ul>
                    <li>Project planning</li>
                    <li>Resource management</li>
                    <li>Risk mitigation</li>
                    <li>Quality assurance</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Value-Added Services */}
      <div id="value-added" className="service-section">
        <div className="container">
          <div className="service-header">
            <div className="service-icon-large">
              <i className="fas fa-plus-circle"></i>
            </div>
            <div className="service-content">
              <h2>Value-Added Services</h2>
              <p>Additional services to enhance your IT infrastructure and capabilities</p>
            </div>
          </div>
          <div className="service-image">
            <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Value Added Services" />
          </div>
          <div className="service-details">
            <div className="service-items">
              <div className="service-item">
                <i className="fas fa-shopping-cart"></i>
                <div>
                  <h3>IT Procurement & Licensing</h3>
                  <p>Comprehensive procurement and licensing services for technology solutions.</p>
                  <ul>
                    <li>Vendor management</li>
                    <li>License optimization</li>
                    <li>Volume purchasing</li>
                    <li>Compliance management</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-handshake"></i>
                <div>
                  <h3>Hardware Rentals & Leasing</h3>
                  <p>Flexible hardware rental and leasing options for temporary or seasonal needs.</p>
                  <ul>
                    <li>Short-term rentals</li>
                    <li>Long-term leasing</li>
                    <li>Equipment maintenance</li>
                    <li>Upgrade options</li>
                  </ul>
                </div>
              </div>
              <div className="service-item">
                <i className="fas fa-graduation-cap"></i>
                <div>
                  <h3>Technical Trainings & Workshops</h3>
                  <p>Professional training and skill development programs for IT teams.</p>
                  <ul>
                    <li>Technology training</li>
                    <li>Certification programs</li>
                    <li>Workshop sessions</li>
                    <li>Knowledge transfer</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>Contact our team of certified professionals to discuss your IT requirements</p>
          <a href="/contact" className="btn btn-primary">Contact Us Today</a>
        </div>
      </section>
    </div>
  );
};

export default Services; 